export default "__VITE_ASSET__BrsIy4nG__"